/* House of Raayaa v5 — ONE bag drawer, two in-place views (locked PLP flow):
   Add → quick size/option step (#drawerOptions) → same drawer swaps to the
   bag (#drawerCart). Cart mutations go through the Ajax API; the drawer
   re-renders itself from the cart-drawer-partial section. */
(function () {
  'use strict';

  var drawer = document.getElementById('drawer');
  if (!drawer) return;
  var drawerOverlay = document.getElementById('drawerOverlay');
  var optionsView = document.getElementById('drawerOptions');
  var cartView = document.getElementById('drawerCart');
  var optionsBody = drawer.querySelector('[data-options-body]');

  /* ---- open / close / view swap --------------------------------------
     Dialog focus handling, same pattern as the menu drawer in raayaa-chrome.js:
     focus moves to the visible view's close button, Tab stays inside the
     drawer, and closing returns focus to the element that opened it. */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  var drawerOpener = null;

  function drawerIsOpen() { return drawer.classList.contains('open'); }
  function setOpenersExpanded(expanded) {
    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (opener) {
      opener.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }
  function focusableInDrawer() {
    /* Only the visible view: the hidden one is inert, so its controls cannot take focus. */
    var activeView = drawer.querySelector('.drawer-view.active') || drawer;
    return Array.prototype.slice.call(activeView.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }
  function focusActiveClose() {
    var activeView = drawer.querySelector('.drawer-view.active');
    var closeButton = activeView && activeView.querySelector('[data-drawer-close]');
    if (closeButton) closeButton.focus();
  }
  /* A card inside a dialog (the PDP "See all reviews" dialog) closes that dialog before the bag opens, so its
     button cannot take focus back. The dialog names a visible stand-in in data-return-focus (an element id). */
  function focusReturnTarget(opener) {
    var dialog = opener && opener.closest && opener.closest('dialog[data-return-focus]');
    return (dialog && document.getElementById(dialog.dataset.returnFocus)) || opener;
  }
  function openDrawer(view, opener) {
    /* First, so a modal <dialog> (the all-reviews dialog) can close before the drawer takes focus. */
    document.dispatchEvent(new CustomEvent('raayaa:drawer-open'));
    showView(view || 'cart');
    if (!drawerIsOpen()) drawerOpener = focusReturnTarget(opener || document.activeElement);
    drawer.classList.add('open');
    drawer.removeAttribute('inert');
    drawerOverlay.classList.add('open');
    setOpenersExpanded(true);
    focusActiveClose();
  }
  function closeDrawer() {
    var wasOpen = drawerIsOpen();
    drawer.classList.remove('open');
    drawer.setAttribute('inert', '');
    drawerOverlay.classList.remove('open');
    setOpenersExpanded(false);
    if (wasOpen && drawerOpener && drawerOpener.focus) drawerOpener.focus(); /* return focus to the opener */
    drawerOpener = null;
  }
  /* The inactive view is only transparent (opacity 0), so inert keeps Tab and
     screen readers out of it. */
  function showView(view) {
    optionsView.classList.toggle('active', view === 'options');
    cartView.classList.toggle('active', view === 'cart');
    optionsView.inert = view !== 'options';
    cartView.inert = view !== 'cart';
  }
  setOpenersExpanded(false);
  drawerOverlay.addEventListener('click', closeDrawer);
  /* Capture phase on window: the bag can open from the mobile menu's Bag link
     while the menu drawer stays open. Handling Escape and Tab here first, and
     stopping them, keeps the menu's own document-level trap from pulling focus
     out of the bag. */
  window.addEventListener('keydown', function (e) {
    if (!drawerIsOpen()) return;
    if (e.key === 'Escape') { e.stopPropagation(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    e.stopPropagation();
    var items = focusableInDrawer();
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-drawer-close]')) closeDrawer();
    var opener = e.target.closest && e.target.closest('[data-cart-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer('cart', opener);
    }
  });

  /* ---- config from layout/theme.liquid (locale-aware routes, store money format) */
  var config = window.RAAYAA || {};
  var routes = config.routes || { root: '/', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js' };
  var strings = config.strings || {};

  /* ---- add errors: same message rule as the PDP buy form ---------------- */
  function addErrorMessage(err) {
    return (err && err.description) || strings.addError || 'Could not add to bag.';
  }
  /* A card's quick-add pill has no room for a notice below it: the pill shows
     the message for a few seconds, then its label comes back. A hidden alert
     region announces the same message to screen readers. */
  var errorAnnouncer = null;
  function announceError(message) {
    if (!errorAnnouncer) {
      errorAnnouncer = document.createElement('div');
      errorAnnouncer.className = 'visually-hidden';
      errorAnnouncer.setAttribute('role', 'alert');
      document.body.appendChild(errorAnnouncer);
    }
    errorAnnouncer.textContent = message;
  }
  function flashButtonError(button, err) {
    var message = addErrorMessage(err);
    if (!button.dataset.labelHtml) button.dataset.labelHtml = button.innerHTML;
    button.textContent = message;
    /* is-error lets a long message wrap inside a narrow card instead of running past its edge */
    button.classList.add('is-error');
    button.removeAttribute('aria-disabled');
    announceError(message);
    window.clearTimeout(Number(button.dataset.errorTimer));
    button.dataset.errorTimer = window.setTimeout(function () {
      button.classList.remove('is-error');
      button.innerHTML = button.dataset.labelHtml;
      delete button.dataset.labelHtml;
    }, 4000);
  }
  /* The options step and the gift-wrap toggle get a notice line under the control. */
  function showNotice(anchor, err) {
    var notice = anchor.nextElementSibling;
    if (!notice || !notice.hasAttribute('data-cart-error')) {
      notice = document.createElement('div');
      notice.setAttribute('data-cart-error', '');
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'font-size:12.5px;color:var(--ink);margin-top:10px';
      anchor.insertAdjacentElement('afterend', notice);
    }
    notice.textContent = addErrorMessage(err);
  }

  /* ---- money: render cents through the store's money format ------------ */
  function formatMoney(cents) {
    var format = config.moneyFormat || '{{amount}}';
    var lang = document.documentElement.lang || undefined;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      var noDecimals = key.indexOf('no_decimals') !== -1;
      var amount = cents / 100;
      if (noDecimals) amount = Math.round(amount);
      return amount.toLocaleString(lang, {
        minimumFractionDigits: noDecimals ? 0 : 2,
        maximumFractionDigits: noDecimals ? 0 : 2
      });
    });
  }

  /* ---- refresh the bag from the section rendering API ----------------
     Each cart mutation asks for the drawer section in the same request
     (Shopify bundled section rendering: `sections` + `sections_url`), so the
     bag repaints without a second round trip. refreshDrawer() takes that
     mutation's JSON; when the section is missing or null, it falls back to
     the separate section request. */
  var DRAWER_SECTION = 'cart-drawer-partial';
  function withDrawerSection(payload) {
    payload.sections = DRAWER_SECTION;
    payload.sections_url = routes.root;
    return payload;
  }
  function refreshDrawer(cartResponse) {
    var bundledHtml = cartResponse && cartResponse.sections && cartResponse.sections[DRAWER_SECTION];
    if (bundledHtml) {
      applyDrawerHtml(bundledHtml);
      return Promise.resolve();
    }
    return fetch(routes.root + '?section_id=' + DRAWER_SECTION)
      .then(function (response) { return response.text(); })
      .then(applyDrawerHtml);
  }
  function applyDrawerHtml(html) {
    var parsed = document.createElement('div');
    parsed.innerHTML = html;
    var freshLines = parsed.querySelector('[data-cart-drawer-lines]');
    var freshFoot = parsed.querySelector('[data-cart-drawer-foot]');
    var freshCount = parsed.querySelector('[data-cart-drawer-count]');
    if (freshLines) drawer.querySelector('[data-cart-drawer-lines]').innerHTML = freshLines.innerHTML;
    if (freshFoot) drawer.querySelector('[data-cart-drawer-foot]').innerHTML = freshFoot.innerHTML;
    var count = freshCount ? freshCount.textContent.trim() : '';
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = count !== '0' ? 'inline-flex' : 'none';
    });
    var drawerCount = drawer.querySelector('[data-cart-drawer-count]');
    if (drawerCount) drawerCount.textContent = count;
    document.dispatchEvent(new CustomEvent('raayaa:content-updated'));
  }
  /* JSON body of a cart mutation, or its error thrown for the caller's catch. */
  function cartJson(response) {
    if (!response.ok) return response.json().then(function (err) { throw err; });
    return response.json();
  }
  function postCart(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(cartJson);
  }

  /* ---- add to cart ---------------------------------------------------- */
  function addToCart(variantId, quantity, properties) {
    var payload = { items: [{ id: variantId, quantity: quantity || 1 }] };
    if (properties) payload.items[0].properties = properties;
    return postCart(routes.cartAdd, withDrawerSection(payload));
  }

  /* ---- quick add: straight add or the options step -------------------- */
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-quick-add]');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    /* aria-disabled, not disabled: the pill sits inside the card link, and a
       click on a disabled button may reach that link. */
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');
    if (button.dataset.variantId) {
      addToCart(button.dataset.variantId)
        .then(refreshDrawer)
        .then(function () {
          button.removeAttribute('aria-disabled');
          /* a retry that succeeds while an earlier error still shows: restore the label now */
          if (button.dataset.labelHtml) {
            window.clearTimeout(Number(button.dataset.errorTimer));
            button.classList.remove('is-error');
            button.innerHTML = button.dataset.labelHtml;
            delete button.dataset.labelHtml;
          }
          openDrawer('cart', button);
        })
        .catch(function (err) { flashButtonError(button, err); });
    } else {
      openOptionsStep(button);
    }
  });

  function openOptionsStep(button) {
    fetch(routes.root + 'products/' + button.dataset.productHandle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed: ' + response.status);
        return response.json();
      })
      .then(function (product) {
        button.removeAttribute('aria-disabled');
        renderOptions(product);
        openDrawer('options', button);
      })
      .catch(function (err) { flashButtonError(button, err); });
  }

  /* Product data is store-authored, but it still goes through innerHTML —
     escape every interpolated value so markup in a title/option never executes. */
  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function renderOptions(product) {
    var selected = {};
    var image = product.featured_image ? '<img src="' + escapeHtml(product.featured_image) + '&width=128" alt="" style="width:64px;height:64px;object-fit:cover;border:var(--hair);background:var(--paper-2)">' : '';

    var optionsMarkup = product.options.map(function (option, optionIndex) {
      var values = option.values.map(function (value) {
        return '<button type="button" class="qa-opt" data-option-index="' + optionIndex + '" data-option-value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</button>';
      }).join('');
      return '<div style="margin-bottom:22px"><div class="label" style="margin-bottom:10px">' + escapeHtml(option.name) + '</div><div style="display:flex;flex-wrap:wrap;gap:8px" data-option-group>' + values + '</div></div>';
    }).join('');

    optionsBody.innerHTML =
      '<div style="display:flex;gap:14px;align-items:center;margin-bottom:24px">' + image +
      '<div><div style="font-size:14px;font-weight: 400">' + escapeHtml(product.title) + '</div>' +
      '<div class="tnum" style="font-size:14px;margin-top:4px" data-options-price>' + formatMoney(product.price) + '</div></div></div>' +
      optionsMarkup +
      '<button type="button" class="btn btn-block" data-options-add disabled style="opacity:.5">' + escapeHtml(optionsBody.dataset.labelAdd || 'Add to bag') + '</button>' +
      '<div style="text-align:center;margin-top:14px"><a class="ulink" style="font-size:13px" href="' + escapeHtml(product.url) + '">' + escapeHtml(optionsBody.dataset.labelView || 'View full details') + ' →</a></div>';

    var addButton = optionsBody.querySelector('[data-options-add]');

    function currentVariant() {
      if (Object.keys(selected).length !== product.options.length) return null;
      return product.variants.find(function (variant) {
        return variant.options.every(function (value, index) { return selected[index] === value; });
      });
    }

    optionsBody.querySelectorAll('.qa-opt').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('[data-option-group]');
        group.querySelectorAll('.qa-opt').forEach(function (sibling) { sibling.classList.remove('sel'); });
        pill.classList.add('sel');
        selected[Number(pill.dataset.optionIndex)] = pill.dataset.optionValue;
        var variant = currentVariant();
        if (variant) {
          optionsBody.querySelector('[data-options-price]').textContent = formatMoney(variant.price);
          addButton.disabled = !variant.available;
          addButton.style.opacity = variant.available ? '1' : '.5';
          addButton.textContent = variant.available
            ? (optionsBody.dataset.labelAdd || 'Add to bag')
            : (optionsBody.dataset.labelSoldout || 'Sold out');
        } else if (Object.keys(selected).length === product.options.length) {
          /* Every option picked but no variant has this combination: back to the
             step's starting state (Add disabled), so the last variant is not kept. */
          optionsBody.querySelector('[data-options-price]').textContent = formatMoney(product.price);
          addButton.disabled = true;
          addButton.style.opacity = '.5';
          addButton.textContent = optionsBody.dataset.labelAdd || 'Add to bag';
        }
      });
    });

    addButton.addEventListener('click', function () {
      var variant = currentVariant();
      if (!variant) return;
      addButton.disabled = true;
      addToCart(variant.id)
        .then(refreshDrawer)
        .then(function () {
          showView('cart');
          focusActiveClose(); /* the focused Add button just left the screen */
        })
        .catch(function (err) {
          addButton.disabled = false;
          showNotice(addButton, err);
        });
    });

    // Single-option products with one value: preselect it
    optionsBody.querySelectorAll('[data-option-group]').forEach(function (group) {
      var pills = group.querySelectorAll('.qa-opt');
      if (pills.length === 1) pills[0].click();
    });
  }

  /* ---- line quantity / remove ----------------------------------------- */
  /* Each button carries an absolute quantity rendered with the bag. One change
     runs at a time per line. A click while that line's change is pending is
     not dropped: it moves the line's target by the same step (the button's
     quantity minus the quantity the bag showed), and when the pending change
     finishes the latest target is sent if it differs from what was sent. A
     refused change (for example, more than the stock) repaints the bag, shows
     why under that line, and drops the queued target. */
  var lineChanges = {}; /* lineKey → { sent: quantity in flight, target: latest wanted quantity } */
  function sendLineChange(lineKey, quantity) {
    lineChanges[lineKey].sent = quantity;
    /* A removal in flight cannot be undone by key (the line is gone once it lands), so the line's controls
       take no more clicks until the bag repaints without it. */
    if (quantity === 0) {
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-line-key]'), function (el) {
        if (el.dataset.lineKey !== lineKey) return;
        Array.prototype.forEach.call(el.querySelectorAll('[data-line-qty]'), function (b) { b.setAttribute('aria-disabled', 'true'); });
      });
    }
    postCart(routes.cartChange, withDrawerSection({ id: lineKey, quantity: quantity }))
      .then(function (cartResponse) {
        return refreshDrawer(cartResponse).then(function () { return true; });
      }, function (err) {
        return refreshDrawer().then(function () {
          var freshLine = Array.prototype.filter.call(drawer.querySelectorAll('[data-line-key]'), function (el) {
            return el.dataset.lineKey === lineKey;
          })[0];
          var controls = freshLine && freshLine.querySelector('[data-line-controls]');
          if (controls) showNotice(controls, err);
          else announceError(addErrorMessage(err));
          return false;
        });
      })
      .catch(function () { return false; }) /* the bag repaint itself failed */
      .then(function (succeeded) {
        var change = lineChanges[lineKey];
        if (succeeded && change.target !== change.sent) sendLineChange(lineKey, change.target);
        else delete lineChanges[lineKey];
      });
  }
  document.addEventListener('click', function (e) {
    var qtyButton = e.target.closest && e.target.closest('[data-line-qty]');
    if (!qtyButton || !drawer.contains(qtyButton)) return;
    var line = qtyButton.closest('[data-line-key]');
    if (!line) return;
    var lineKey = line.dataset.lineKey;
    var buttonQuantity = Number(qtyButton.dataset.lineQty);
    var pending = lineChanges[lineKey];
    if (pending && pending.sent === 0) return; /* removal already in flight (see sendLineChange) */
    if (!pending) {
      lineChanges[lineKey] = { sent: buttonQuantity, target: buttonQuantity };
      sendLineChange(lineKey, buttonQuantity);
      return;
    }
    /* The buttons on screen still belong to the bag before the pending change, so read the click as a step
       from that bag's quantity. Only the Remove button is absolute: a minus button can also carry 0
       (quantity 1 − 1), and after a queued + it must step back, not remove the line. */
    var shownQuantity = Number(line.dataset.lineQuantity);
    if (qtyButton.hasAttribute('data-line-remove')) pending.target = 0;
    else if (isNaN(shownQuantity)) pending.target = buttonQuantity;
    else pending.target = Math.max(0, pending.target + (buttonQuantity - shownQuantity));
  });

  /* ---- gift note -------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-cart-note-form]');
    if (!form || !drawer.contains(form)) return;
    e.preventDefault();
    /* A failed save still repaints the bag, as before, so the note field shows what the cart holds. */
    postCart(routes.cartUpdate, withDrawerSection({ note: form.querySelector('[name="note"]').value }))
      .then(refreshDrawer, function () { return refreshDrawer(); });
  });

  /* ---- gift-wrap toggle (drawer foot + /cart page) ---------------------- */
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-gift-wrap-toggle]');
    if (!toggle) return;
    toggle.disabled = true;
    var inDrawer = drawer.contains(toggle);
    /* The /cart page reloads after the change. Its quantity fields and gift note
       are saved first (the same fields its Update button posts), so a reload
       does not wipe what the shopper typed. The lines are unchanged at this
       point, so the positional updates[] still match them. */
    var cartPageForm = !inDrawer && toggle.form;
    var saveCartPage = cartPageForm
      ? fetch(routes.cartUpdate, { method: 'POST', body: new FormData(cartPageForm) }).then(cartJson)
      : Promise.resolve();
    var mutation = saveCartPage.then(function () {
      return toggle.checked
        ? addToCart(toggle.dataset.variantId)
        : postCart(routes.cartChange, withDrawerSection({ id: toggle.dataset.lineKey, quantity: 0 }));
    });
    mutation.then(function (cartResponse) {
      /* The /cart page is server-rendered, so it reloads instead of patching. */
      if (inDrawer) return refreshDrawer(cartResponse);
      window.location.reload();
    }, function (err) {
      /* The cart did not change: put the checkbox back and let the shopper retry. */
      toggle.checked = !toggle.checked;
      toggle.disabled = false;
      showNotice(toggle.closest('label') || toggle, err);
    });
  });

  /* ---- PDP buy form intercepts into the drawer -------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-buy-form]');
    if (!form) return;
    e.preventDefault();
    /* One add at a time: a double click on Add to bag (or the sticky bar's
       button, which submits the same form) must not add the piece twice. */
    if (form.dataset.addPending === 'true') return;
    form.dataset.addPending = 'true';
    var formData = new FormData(form);
    formData.append('sections', DRAWER_SECTION);
    formData.append('sections_url', routes.root);
    fetch(routes.cartAdd, { method: 'POST', body: formData })
      .then(cartJson)
      .then(refreshDrawer)
      .then(function () { openDrawer('cart'); })
      .catch(function (err) {
        var message = (err && err.description) || strings.addError || 'Could not add to bag.';
        var notice = form.querySelector('[data-buy-error]');
        if (notice) { notice.textContent = message; notice.style.display = 'block'; }
      })
      .then(function () { delete form.dataset.addPending; });
  });
})();
